<template>
    <div class="card p-5 bg-light-primary">
        <div class="d-flex flex-stack">
            <div class="symbol symbol-60px me-4">
                <div class="symbol-label fs-1 bg-white">
                    <span :class="color">{{ Math.round(count) }}{{ unit }}</span>
                </div>
            </div>
            <div class="d-flex align-items-center flex-row-fluid flex-wrap">
            <div class="flex-grow-1 me-2">
            <a class="text-black fs-2 fw-bolder">
                {{title}}
            </a>
            <div class="display-6" :class="color">{{ amountFormatter.formatNumber( amount) }} <span class="text-dark-50 font-weight-bold">{{ iso }}</span></div>
            </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useFormatAmount } from '@/composables/formatAmount';

const props = defineProps({
    title: {type: String},
    count: {type: [String, Number]},
    amount: {type: Number},
    iso: {type: String},
    color: {type: String},
    unit: {type: String, default: ''}

})
const amountFormatter = useFormatAmount() 

</script>